import { Button, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import IosSwitch from '../../../common/IosSwitch';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Upload from '../../../common/Upload';
import BasicModal from '../../../common/BasicModal';
import { IPackage } from '../../../../interfaces/campaign';
import { GridColDef, DataGrid, GridEventListener } from '@mui/x-data-grid';
import i18next from 'i18next';
import { CampaignContext } from '../../../../contexts/CampaignContext';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';

const AddPackage = () => {
	const { fetchedMedias } = useContext(CampaignContext);
	const { t } = useTranslation();
	const { type, id } = useParams();
	const [files, setFiles] = useState<(File | string)[]>([]);
	const [fetchPages, setFetchPages] = useState<IPackage[]>([]);
	const [title, setTitle] = useState<string>('');
	const [selectPlatform, setPlatform] = useState<string | null>(null);
	const [price, setPrice] = useState<string | null>(null);
	const [viewCampaign, setViewCampaign] = useState<boolean>(false);
	const [reserveCampaign, setReserveCampaign] = useState<boolean>(false);
	const [isActive, setIsActive] = useState<boolean>(false);
	const [contentType, setContentType] = useState<string | null>('post');
	const [selectPage, setSelectPage] = useState('');
	const [finalClickInfo, setFinalClickInfo] = useState<any>(null);
	const [pageSelected, setPageSelected] = useState<any>([]);
	const [openModal, setOpenModal] = useState<boolean>(false);
	const navigate = useNavigate();
	const headerClassNames = 'text-xs bg-background-paper';
	let filter_media = fetchedMedias?.filter(item => item.is_social === true);
	const handleChange = (event: any) => {
		setPageSelected({ priceList: event.target.value.prices, id: event.target.value.id });
		setSelectPage(event.target.value as string);
	};

	const handleOpenModal = () => {
		setOpenModal(!openModal);
	};

	const handleCreatePackage = () => {
		let formData = new FormData();
		formData.append('title', title);
		formData.append('media_id', selectPlatform ?? '');
		formData.append('package_type', contentType ?? '');
		formData.append('price', price ?? '');
		formData.append('view_campaign', viewCampaign === false ? '0' : '1');
		formData.append('reserve_campaign', reserveCampaign === false ? '0' : '1');
		formData.append('is_active', isActive === false ? '0' : '1');
		formData.append('entities[0][price_id]', finalClickInfo?.id ?? '');
		formData.append('entities[0][id]', pageSelected?.id ?? '');
		formData.append('image', files[0] ?? new Blob());
		formData.append('_method', 'put');
		axios({
			url: `/admin/media-packages/${id}`,
			method: 'post',
			data: formData,
		}).then(res => {
			if (res.data.success) {
				navigate(`/campaigns/chanels/`);
			}
		});
	};

	const handlefetchPages = () => {
		axios({
			url: `/admin/media-entities`,
		}).then(res => {
			if (res.data.success) {
				setFetchPages(res.data.data);
			}
		});
	};

	const handleFetchMedia = () => {
		axios({
			url: `/admin/media-packages/${id}`,
		}).then(res => {
			if (res.data.success) {
				let data = res.data.data;
				setTitle(data.title);
				setPrice(data.price);
				setPlatform(data.media_id);
				setFiles(Array.isArray(data.image) ? data.image : [data.imageّ]);
			}
		});
	};

	const handleDeletePage = (id: number) => {
		axios({
			url: `/admin/media-entities/${id}`,
			method: 'DELETE',
		}).then(res => {
			if (res.data.success) {
				handlefetchPages();
			}
		});
	};

	const handleEvent: GridEventListener<'rowClick'> = params => {
		setFinalClickInfo(params.row);
	};

	const columns: GridColDef[] = [
		{ field: 'title', flex: 1, headerClassName: headerClassNames, headerName: i18next.t('panel') },
		{
			field: 'action',
			flex: 1,
			headerClassName: headerClassNames,
			align: 'center',
			headerAlign: 'center',
			headerName: i18next.t('action'),
			renderCell: (params: any) => {
				let data = params.row;
				return (
					<>
						<IconButton onClick={() => setFinalClickInfo(data)}>{finalClickInfo && finalClickInfo.id === data.id ? <DoneIcon className="text-text-secondary" /> : <AddIcon className="text-text-secondary" />}</IconButton>
						<IconButton onClick={() => handleDeletePage(data.id)}>
							<DeleteOutlineIcon className="text-text-secondary" />
						</IconButton>
					</>
				);
			},
		},
	];

	useEffect(() => {
		if (id && id !== null) {
			handleFetchMedia();
		}
		handlefetchPages();
	}, []);
	return (
		<>
			<div className="flex w-full flex-col rounded-lg">
				<div className="bg-white p-6">
					<Typography className="text-xl font-bold">{id ? t('edit_user', { type: t(type!) }) : t('create_new_user', { type: t(type!) })}</Typography>

					<form className="mx-auto flex w-full flex-col justify-between gap-6 rounded-lg bg-white p-5">
						<div className="flex w-full items-start justify-between gap-2">
							<div className="flex w-full flex-col gap-5">
								<TextField id="title" onChange={e => setTitle(e.target.value)} className="w-full" value={title ? title : ''} label={t('title')} variant="outlined" />
								<TextField id="price" className="w-full" onChange={e => setPrice(e.target.value)} value={price ? price : ''} label={t('price')} variant="outlined" />
								<FormControl fullWidth>
									<InputLabel id="release-platform">{t('release-platform')}</InputLabel>
									<Select labelId="release-platform" value={selectPlatform ? selectPlatform : ''} size="small" onChange={(e: SelectChangeEvent<string>) => setPlatform(e.target.value)}>
										{filter_media?.map(item => <MenuItem value={item.id}>{item.title}</MenuItem>)}
									</Select>
								</FormControl>
								<FormControl fullWidth>
									<InputLabel id="content_type">{t('content_type')}</InputLabel>
									<Select labelId="content_type" value={contentType} size="small" onChange={e => setContentType(e.target.value)}>
										<MenuItem value="post">{t('post')}</MenuItem>
										{(selectPlatform == '2' || selectPlatform == '11') && <MenuItem value="story">{t('story')}</MenuItem>}
									</Select>
								</FormControl>
							</div>
							<div className="flex w-full flex-col gap-2">
								<Upload className="w-full" setFiles={setFiles} files={files} text={t('upload_image')} />
								<div className="flex gap-4">
									<IosSwitch name="status" checked={isActive} setValue={setIsActive} label={t('status')} />
									<IosSwitch name="reserve_campaign" checked={reserveCampaign} setValue={setReserveCampaign} label={t('reserve_campaign')} />
									<IosSwitch name="view_campaign" checked={viewCampaign} setValue={setViewCampaign} label={t('view_campaign')} />
								</div>
								<Button onClick={() => handleOpenModal()}>{t('add_chanels_packages')}</Button>
							</div>
						</div>
					</form>
					<Button onClick={() => handleCreatePackage()}>{t('register')}</Button>
				</div>
				{pageSelected.priceList && pageSelected.priceList.length >= 0 && (
					<Paper>
						<DataGrid onRowClick={handleEvent} rows={pageSelected.priceList} hideFooter hideFooterPagination disableRowSelectionOnClick hideFooterSelectedRowCount columns={columns} sx={{ border: 0 }} />
					</Paper>
				)}
			</div>

			<BasicModal
				open={!!openModal}
				onClose={handleOpenModal}
				title={t('add_pages')}
				titleClassName={'text-center grow '}
				subClassName={'flex flex-row-reverse'}
				className={'max-w-xl rounded-lg'}
				showBackIcon={false}
				action={
					<div className="w-full">
						<Button onClick={handleOpenModal} variant="contained" color="primary" className="mx-2">
							{t('register')}
						</Button>
						<Button onClick={handleOpenModal} variant="outlined" className="mx-2" color="error">
							{t('cancel')}
						</Button>
					</div>
				}
			>
				<FormControl fullWidth className="my-4">
					<InputLabel>{t('add_chanels_packages')}</InputLabel>
					<Select value={selectPage} label="Age" onChange={handleChange}>
						{fetchPages?.map((item: any) => <MenuItem value={item}>{item.title}</MenuItem>)}
					</Select>
				</FormControl>
			</BasicModal>
		</>
	);
};

export default AddPackage;
